'use strict'
import { useState, useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchSidebarMenuInfo } from '../features/dashboard/redux/actionCreator'

// using this hook to refresh the hamburg menu when any action executed by site, asset and device
const useRefreshHamburgNotifier = () => {
  const [actionState, setActionState] = useState({
    type: null,
    action: null,
    timestamp: null
  })
  const dispatch = useDispatch()

  const refreshHamburgAction = useCallback((type, action) => {
    setActionState({
      type,
      action,
      timestamp: new Date().toISOString()
    })
  }, [])

  useEffect(() => {
    if (actionState.type && actionState.type) {
      dispatch(fetchSidebarMenuInfo())
    }
  }, [actionState])

  return { refreshHamburgAction }
}

export default useRefreshHamburgNotifier
